import { Stack } from 'expo-router';

const OnboardingLayout = () => <Stack screenOptions={{ headerShown: false }} />;

export default OnboardingLayout;
